import createSvgIcon from "./utils/create_icon"

const FrameSizeSmall = createSvgIcon(<path clipRule="evenodd" d="M15 8H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM9 6a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3z" fill="currentColor" fillRule="evenodd" />, "FrameSizeSmall")
export default FrameSizeSmall
